import { SVGProps } from "react";
const TrendingSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      stroke="#2A2D31"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5 15.889 5.071-5.071a.999.999 0 0 1 1.414 0l2.141 2.141a.999.999 0 0 0 1.414 0L21 7"
    />
    <path
      stroke="#2A2D31"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.333 7H21v2.667M21 20.929H1.925V3.22"
    />
  </svg>
);
export default TrendingSvg;
